import { CircularProgress } from "@material-ui/core";
import { VerifiedUser } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { Link, withRouter } from "react-router-dom";
import { invokeApi } from "../../../bl_libs/invokeApi";
import { useSockets } from "../../../Context/Context-Sockets/ContextSockets";

function PhoneNumberScreen(props) {
  const { socketON } = useSockets();
  const {
    setOpenPhoneNumberScreen,
    auth,
    handleReqPostData,
    reqPostData,
  } = props;

  console.log(props, "PROPS");

  const [code, setCode] = useState();

  const [phone, setPhone] = useState("");

  const [isLoading, setIsLoading] = React.useState(false);

  const [screen, setScreen] = React.useState("ENTER_PHONE");

  const EmailAndPhoneVarification = () => {
    let requestObj = {
      path: "/app_api/validateEmailandPhone",
      method: "POST",
      headers: {},
    };
    let postData = {
      email: auth.email,
      phone: `${phone}`,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        SendCodeOnPhone();
      } else {
        setIsLoading(false);
      }
    });
  };

  const SendCodeOnPhone = () => {
    let requestObj = {
      path: "/app_api/send_verification_code_on_ph_number",
      method: "POST",
      headers: {},
    };
    let postData = {
      phonenumber: `+1${phone}`,
      channel: "sms",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setScreen("ENTER_CODE");
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const verifyPhone = () => {
    let requestObj = {
      path: "/app_api/verify_code_send_on_phone_number",
      method: "POST",
      headers: {},
    };
    let postData = {
      phonenumber: `+1${phone}`,
      code: code,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        if (auth.authType === "google") {
          UserSignupWithGoogle();
        } else {
          UserSignupWithFacebook();
        }
      } else {
        setIsLoading(false);
      }
    });
  };

  const UserSignupWithGoogle = () => {
    let requestObj = {
      path: "/api/customer/login_by_google",
      method: "POST",
      headers: {},
    };
    let postData = {
      access_token: `${auth.accessToken}`,
      phone_number: `${phone}`,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        let storage_obj = {
          ...res.data,
          ...res.data.user,
        };

        if (reqPostData) {
          handleReqPostData(res.data.auth_token, storage_obj);
          return;
        }

        localStorage.setItem("token", res.data.auth_token);
        localStorage.setItem("user", JSON.stringify(storage_obj));
        props.history.push("/create-request");
        socketON();
      } else {
        setIsLoading(false);
      }
    });
  };

  const UserSignupWithFacebook = () => {
    let requestObj = {
      path: "/api/customer/login_by_facebook",
      method: "POST",
      headers: {},
    };
    let postData = {
      access_token: `${auth.accessToken}`,
      phone_number: `${phone}`,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        let storage_obj = {
          ...res.data,
          ...res.data.user,
        };

        if (reqPostData) {
          handleReqPostData(res.data.auth_token, storage_obj);
          return;
        }

        localStorage.setItem("token", res.data.auth_token);
        localStorage.setItem("user", JSON.stringify(storage_obj));
        props.history.push("/create-request");
        socketON();
      } else {
        setIsLoading(false);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    EmailAndPhoneVarification();
  };

  const handleSubmitCode = () => {
    verifyPhone();
  };

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress />
      </div>
    );
  }

  if (screen === "ENTER_PHONE") {
    return (
      <section className="main-content">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-xl-4 ">
              <div className="form-box-wrapper">
                <div className="form-box">
                  <h5 className="text-center">Enter your phone</h5>

                  <div className="evom-form login-form">
                    <form onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div></div>
                        <div className="col-12">
                          <div className="form-group">
                            <label
                              htmlFor="email"
                              className="overline dark-grey-color"
                            >
                              Enter Your Phone Number
                            </label>
                            <NumberFormat
                              required
                              onChange={(e) => {
                                setPhone(e.target.value);
                              }}
                              className="form-control small-font-size"
                              id="phone"
                              value={phone}
                              placeholder="(217) 555-0113"
                              format="(###) ###-####"
                              allowLeadingZeros
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12">
                          <div className="form-group button-wrapper">
                            <button className="custom-buton custom-buton-large w-100">
                              Verify
                            </button>
                          </div>

                          <div className="no-account-text-wrapper-custom text-center mt-4 pt-4">
                            <p className="light-grey-color">
                              Return to{" "}
                              <span
                                onClick={() => setOpenPhoneNumberScreen(false)}
                                className="custom-link pointer-point"
                              >
                                Log In
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="no-account-text-wrapper-custom text-center mt-4 pt-4 mt-sm-5 pt-sm-5"></div>
        </div>
      </section>
    );
  }

  if (screen === "ENTER_CODE") {
    return (
      <section className="main-content">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-xl-4 ">
              <div className="form-box-wrapper">
                <div className="form-box">
                  <h5 className="text-center">Check your phone</h5>

                  <div className="evom-form login-form">
                    <form onSubmit={handleSubmitCode}>
                      <div className="row justify-content-center">
                        <div></div>
                        <div className="col-12">
                          <div className="form-group">
                            <label
                              htmlFor="email"
                              className="overline dark-grey-color"
                            >
                              Enter code
                            </label>
                            <NumberFormat
                              required
                              onChange={(e) => {
                                setCode(e.target.value);
                              }}
                              className="form-control small-font-size"
                              id="phone"
                              value={code}
                              placeholder="Enter your 6 digit confirmation code"
                              format="######"
                              mask="-"
                              allowLeadingZeros
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="col-12 col-sm-12">
                          <div className="form-group button-wrapper">
                            <button className="custom-buton custom-buton-large w-100">
                              Verify
                            </button>
                          </div>

                          <div className="no-account-text-wrapper-custom text-center mt-4 pt-4">
                            <p className="light-grey-color">
                              I didn't receive the text message?{" "}
                              <span
                                onClick={SendCodeOnPhone}
                                className="custom-link pointer-point"
                              >
                                Resend
                              </span>
                            </p>
                            <p className="light-grey-color">
                              Return to{" "}
                              <span
                                onClick={() => setOpenPhoneNumberScreen(false)}
                                className="custom-link pointer-point"
                              >
                                Log In
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="no-account-text-wrapper-custom text-center mt-4 pt-4 mt-sm-5 pt-sm-5"></div>
        </div>
      </section>
    );
  }

  return <>Invalid Condition Screen</>;
}

export default withRouter(PhoneNumberScreen);
